
import { axiosInstance } from "../core/http";

export const matchApi = {
  loadMatch: (dump_url, pipelinePassing) =>
    axiosInstance.post("/panel/match/load-dump/", {
      dump_url,
      pipeline_passing: pipelinePassing,
    }),
  getUserReport: (data) => axiosInstance.get(`/panel/pipe-conflict/report/`),
  getMatchesList: (page, search) =>
    axiosInstance.get("/panel/matches/", { params: { page, search } }),
  getMatch: (id) => axiosInstance.get(`/panel/match/${id}/`),
  updateMatch: (id, payload) => axiosInstance.put(`/api/match/${id}/`, payload),
  createMatch: (data) => axiosInstance.post("/panel/match/create/", data),
  getBallConflicts: (matchId, curr_stage) =>
    axiosInstance.get(`/panel/match/${matchId}/ball/detection/`, {
      params: { curr_stage },
    }),
  postBallConflict: ({ matchId, images, curr_stage }) =>
    axiosInstance.post(`/panel/match/${matchId}/ball/detection/update/`, {
      removed_images: images,
      curr_stage,
    }),
  getMatchTask: (matchId, taskId) =>
    axiosInstance.get(`/panel/match/${matchId}/pipe-conflict/${taskId}/`),
  postMatchTask: (matchId, type = "track") =>
    axiosInstance.post(`/panel/match/${matchId}/pipe-conflict/task/`, {
      task_type: type,
    }),
  postMatchTaskResult: ({ matchId, taskId, taskResult, taskType = "" }) =>
    axiosInstance.post(
      `/panel/match/${matchId}/pipe-conflict/${taskId}/update/`,
      {
        task_type: taskType,
        task_result: taskResult,
      }
    ),
  getMatchSuperTracks: (matchId) =>
    axiosInstance.get(`/panel/match/${matchId}/super-tracks/`),
  getMatchSuperTracksFull: (matchId) =>
    axiosInstance.get(`/panel/match/${matchId}/super-tracks-full/`),
  deleteSuperTrack: ({ matchId, superTrackId }) =>
    axiosInstance.delete(
      `/panel/match/${matchId}/super-tracks/${superTrackId}/`
    ),
  updateSuperTrack: ({ matchId, id, track, superTrackId }) =>
    axiosInstance.post(
      `/panel/match/${matchId}/super-tracks/${superTrackId}/${id}/${track.track_id}/`
    ),
  getSuperTrackFrames: (matchId, superTrackId) =>
    axiosInstance.get(
      `/panel/match/${matchId}/super-tracks/${superTrackId}/tracks/`
    ),
  updateSuperTrackFrames: (
    matchId,
    superTrackId,
    track_data,
    changed_frames,
    pipe_conflict_id,
    task_range,
    pauses,
    substitution
  ) =>
    axiosInstance.post(
      `/panel/match/${matchId}/super-tracks/${superTrackId}/update/`,
      {
        track_data,
        changed_frames,
        pipe_conflict_id,
        task_range,
        ...(pauses && { pauses }),
        ...(substitution && { substitution_uid: Number(substitution) }),
      }
    ),
  mergeSuperTrack: ({
    matchId,
    id,
    superTrackId,
    pipe_conflict_id,
    task_range,
  }) =>
    axiosInstance.post(`/panel/match/${matchId}/super-tracks/${superTrackId}/merge/`, {
      pipe_conflict_id,
      merge_super_track_uid: id,
      task_range,
    }),
  deleteTrack: ({ matchId, superTrackId, track_id }) =>
    axiosInstance.delete(
      `/panel/match/${matchId}/super-tracks/${superTrackId}/${track_id}/`
    ),
  createSuperTrack: (matchId) =>
    axiosInstance.post(`/panel/match/${matchId}/super-tracks/create/`),
  postSuperTrackPlayer: ({ matchId, superTracksId, kind }) =>
    axiosInstance.post(
      `/panel/match/${matchId}/super-tracks/${superTracksId}/kind/`,
      {
        kind,
      }
    ),
  postSuperTrackJersey: ({ matchId, superTracksId, jersey }) =>
    axiosInstance.post(
      `/panel/match/${matchId}/super-tracks/${superTracksId}/jersey/`,
      {
        jersey,
      }
    ),
  updateSuperTrackStartLineup: ({ matchId, superTrackUid, startLineup }) =>
    axiosInstance.post(
      `/panel/match/${matchId}/super-tracks/${superTrackUid}/start_lineup/`,
      {
        start_lineup: startLineup,
      }
    ),
  postTrackCut: ({
    superTrackId,
    matchId,
    frame,
    trackId,
    pipe_conflict_id,
    track_data,
    changed_frames,
    task_range,
  }) =>
    axiosInstance.post(
      `/panel/match/${matchId}/super-tracks/${superTrackId}/cut/`,
      {
        track_id: trackId,
        frame_cut_id: frame,
        pipe_conflict_id,
        track_data,
        changed_frames,
        task_range,
      }
    ),
  moveTracks: ({
    matchId,
    fromId,
    toId,
    trackIds,
    pipe_conflict_id,
    task_range,
  }) =>
    axiosInstance.post(`/panel/match/${matchId}/super-tracks/${fromId}/replace/`, {
      pipe_conflict_id,
      super_track_uid: fromId,
      new_super_track_uid: toId,
      tracks_ids: trackIds,
      task_range,
    }),
  getFilePath: ({ matchId, fileType }) =>
    axiosInstance.get(`/api/match/${matchId}/file/${fileType}`),
  getEvents: ({ matchId }) =>
    axiosInstance.get("/api/state/event/", { params: { match_id: matchId } }),
  getEventsByUid: ({ matchId, uid }) =>
    axiosInstance.get(`/panel/state/light_event/${matchId}/${uid}`),
  getCurrentTasks: (resolverId) =>
    axiosInstance.get(`/panel/pipe-conflict/resolver/${resolverId}`),
  addTask: ({ match, task_type, task, token }) =>
    axiosInstance.post(
      "/panel/pipe-conflict/create/",
      {
        match,
        task,
        task_type,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    ),
  getTaskStatuses: (matchId) =>
    axiosInstance.get(
      `/panel/match/${matchId}/pipe-conflict/super-track-tasks/`
    ),
  get2Dfrom3D: (matchId, coords) =>
    axiosInstance.post(`/panel/match/${matchId}/field/arrow/`, { coords }),

  // Trigger backend to update supertracks file for a match
  updateMatchFile: (matchId) =>
    axiosInstance.get(`/panel/match/${matchId}/update_supertracks/`),

  // Match time helpers
  getMatchTime: (matchId) =>
    axiosInstance.get(`/panel/matches/${matchId}/match-time/`),

  updateMatchTime: (matchId, matchTime) =>
    axiosInstance.patch(`/panel/matches/${matchId}/match-time/`, {
      match_time: matchTime,
    }),

  updateTeamColors: (matchId, { leftTeamColor, rightTeamColor }) =>
    axiosInstance.patch(`/api/match/${matchId}/`, {
      left_team_jersey_color: leftTeamColor,
      right_team_jersey_color: rightTeamColor,
    }),
  getPipeConflictTasks: (matchId) =>
    axiosInstance.get(`/panel/match/${matchId}/pipe-conflict/`),
  
  // New methods for binding/unbinding matches to orders
  bindMatchToOrder: (matchId, orderNumber) =>
    axiosInstance.post(`/panel/order/${orderNumber}/bind_match/${matchId}/`),
  
  unbindMatchFromOrder: (matchId) =>
    axiosInstance.post(`/panel/match/${matchId}/unbind/`),

  // Training part methods
  getTrainingPart: (matchId, partId) =>
    axiosInstance.get(`/panel/training_part/${matchId}/training_parts/${partId}/`),
};
